import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
//Vue File Agent
import VueFileAgent from 'vue-file-agent';
import 'vue-file-agent/dist/vue-file-agent.css';
// Font Awesome
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
// Vue -tour
import VueTour from 'vue-tour'
require('vue-tour/dist/vue-tour.css')
require('leaflet/dist/leaflet.css')

Vue.use(VueTour)




//icons
import {
    faCheck,
    faCaretRight,
    faCaretLeft,
    faLock,
    faUser,
    faBell,
    faSortDown,
    faBars,
    faArrowRight,
    faQuestion,
    faChevronRight,
    faTimes,
    faCalendarAlt,
    faClock,
    faExpand,
    faPen,
    faShieldAlt,
    faSignOutAlt,
    faInfo
} from '@fortawesome/free-solid-svg-icons'




//--------------------




// Font Awesome
library.add(faCheck)
library.add(faUser)
library.add(faLock)
library.add(faCaretRight)
library.add(faCaretLeft)
library.add(faBell)
library.add(faSortDown)
library.add(faBars)
library.add(faArrowRight)
library.add(faQuestion)
library.add(faChevronRight)
library.add(faTimes)
library.add(faCalendarAlt)
library.add(faClock)
library.add(faExpand)
library.add(faPen)
library.add(faShieldAlt)
library.add(faSignOutAlt)
library.add(faInfo)
Vue.component('font-awesome-icon', FontAwesomeIcon)
    //--------------------

Vue.use(VueFileAgent);

Vue.config.productionTip = false

new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
}).$mount('#app')